import * as _ from "lodash";
import axios from "axios";

class Contracts {
  /**
   * Retorna moveMaisId do contrato caso este possua Parent .
   *
   *  @returns {Promise} Retorna moveMaisId do contrato se Parent associado.
   */
  getMoveMaisIdParent(contractId) {
    return axios
      .get(`/v2/getMoveMaisIdParentByContractId/${contractId}`)
      .then((res) => {
        return res.data.moveMaisId;
      });
  }
  /**
   * Retorna todos os contratos ativos.
   *
   * @returns {Promise} lista com contratos.
   */
  findAll(moveMaisId) {
    return axios
      .get(`/v2/getContractByMoveMaisId/${moveMaisId}`)
      .then((res) => {
        return res.data.contracts;
      });
  }

  getGeneralParameter(key) {
    return axios.post(`/v2/getGeneralParameter`, { key: key }).then((res) => {
      return res.data;
    });
  }
  findAllContractsVw(moveMaisId) {
    return axios
      .get(`/v2/getContractByMoveMaisIdVw/${moveMaisId}`)
      .then((res) => {
        return res.data.contracts;
      });
  }
  /**
   * Retorna todos os contratos do usuario logado.
   *
   * @returns {Promise} contratos
   */
  getContract() {
    return axios.get("/v2/getContract").then((res) => {
      return res.data.contracts;
    });
  }

  getContractData(moveMaisId) {
    return axios.get(`/v2/getContractData/${moveMaisId}`).then((res) => {
      return res.data;
    });
  }

  /**
   * Retorna retorna o contrato logado.
   *
   * @returns {Promise} retorna o contrato logado.
   */
  getContractByContractId(contractId) {
    return axios
      .get(`/v2/getContractByContractId/${contractId}`)
      .then((res) => {
        return res.data.contract;
      });
  }

  /**
   * Solicita o cancelamento do contrato
   *
   * @returns {Promise} Promisse com o status do resultado.
   */
  cancel(contractId) {
    return axios.delete(`/v1/cancelContract/${contractId}`);
  }

  updateContract(contract) {
    return axios.post("/v2/updateRechargeTax", contract);
  }

  updateContractValueRecharge(contractId, valueRecharge) {
    return axios.get(
      `/v2/updateContractValueRecharge/${contractId}/${valueRecharge}`,
    );
  }
  /**
   * Solicita o cancelamento do contrato
   * @param contractId se passado null a consulta é realizada pelo movemaisid
   * @returns {Promise} Promisse com o status do resultado.
   */
  getPaymentMethod(contractId) {
    let url = `/v2/getPaymentMethod`;
    url += contractId ? `/${contractId}` : "";
    return axios.get(url).then((res) => {
      return res.data.list;
    });
  }

  getPaymentMethodPm(contractId) {
    let url = `/v2/getPaymentMethodPm`;
    url += contractId ? `/${contractId}` : "";
    return axios.get(url).then((res) => {
      return res.data.list;
    });
  }

  ValidacaoNetrim(cpf, dataNascimento) {
    return axios
      .get(`/v2/netrim/validacaoNetrim/${cpf}/${dataNascimento}`)
      .then((res) => {
        return res.data;
      });
  }

  InsereNetrimLog(cpf, dataNascimento, codeError) {
    return axios
      .post(`/v2/netrim/InsereNetrimLog/${cpf}/${dataNascimento}/${codeError}`)
      .then((res) => {
        return res.data;
      });
  }

  ConsultaNetrimLog(cpf, dataNascimento, token) {
    return axios
      .get(`/v2/netrim/ConsultaNetrimLog/${cpf}/${dataNascimento}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        return res.data;
      });
  }

  getRechargesRoadcard(planId) {
    return axios
      .get(`/v2/roadcard/informacoes-do-plano/${planId}`)
      .then((res) => {
        return res.data;
      });
  }

  updateContractName(contractId, name) {
    return axios.post("/v2/updateContractName", {
      contractId: contractId,
      name: name,
    });
  }

  cancelContract(contractId) {
    return axios.delete(`/v1/updateContractName/${contractId}`);
  }

  getListChildAccount() {
    return axios.get(`/v2/getListChildAccount`).then((res) => {
      return res.data;
    });
  }

  getListInvoice(contractId) {
    return axios.get(`/v1/getListInvoice/${contractId}`).then((res) => {
      return res.data.invoices.invoice;
    });
  }

  getSummaryVehicles(contractId) {
    return axios.get(`/v2/getSummaryVehicles/${contractId}`).then((res) => {
      return res.data.summary;
    });
  }

  getContractListSimple(taxId, currentTaxId, planId = 0) {
    return axios
      .get(`/v2/getContractListSimple/${taxId}/${currentTaxId}/${planId}`)
      .then((res) => {
        return res.data;
      });
  }

  getUpdateValueAlert(lcFlag, limitCredit, contractId) {
    return axios
      .get(`/v2/getUpdateValueAlert/${lcFlag}/${limitCredit}/${contractId}`)
      .then((res) => {
        return res.data;
      });
  }
  checkStatusMigration(moveMaisId) {
    return axios.get(`/v2/checkStatusMigration/${moveMaisId}`).then((res) => {
      return res.data;
    });
  }

  getRoadcardTax() {
    return axios.get(`/v2/roadcard/getAdhesionTaxHotsite`).then((res) => {
      return res.data;
    });
  }

  getGroupers(moveMaisId) {
    return axios
      .get(`/v2/agrupadorVPO/getAgrupadoresByIdCliente/${moveMaisId}`)
      .then((res) => {
        return res.data;
      });
  }

  getUrlMoveCargo() {
    return axios.get(`/v2/getUrlMoveCargo`).then((res) => {
      return res.data;
    });
  }

  getDetailPlanVp(newVal) {
    return axios.get(`/v2/getDetailPlanVp/${newVal}`).then((res) => {
      return res.data;
    });
  }

  disableGrouper(idAgrupador) {
    return axios
      .post(`/v2/agrupadorVPO/inactivateAgrupador`, { idAgrupador })
      .then((res) => {
        return res.data;
      });
  }

  addGrouper(name, description, moveMaisId) {
    return axios
      .post(`/v2/agrupadorVPO/createAgrupador`, {
        nome: name,
        descricao: description,
        idClienteVpo: moveMaisId,
      })
      .then((res) => {
        return res.data;
      });
  }

  editGrouper(name, description, idAgrupador) {
    return axios
      .post(`/v2/agrupadorVPO/updateAgrupador`, {
        nome: name,
        descricao: description,
        idAgrupador,
      })
      .then((res) => {
        return res.data;
      });
  }
}

const instance = new Contracts();
export default instance;



// WEBPACK FOOTER //
// ./src/services/contracts.js